import { ExtendedUser, RoleAssignmentStatus } from '../../../../store/users/types';

export const hasUserRolesOrGrants = (user: ExtendedUser) =>
  user.roleAssignmentStatus === RoleAssignmentStatus.DONE
  && user.userRoles
  && user.userRoles.some(role => role !== 'NONE');
